<template>
  <section
    class="antialiased font-sans w-full bg-grey-lighter text-left text-black py-8"
  >
    <div class="container mx-auto max-w-xl py-8 font-normal leading-normal">
      <h3 class="text-2xl">{{ title }}</h3>
      <p class>{{ subtitle }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "pagehero",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    cta: {
      type: Boolean,
      default: true
    }
  }
};
</script>
